import React, { useEffect, useState } from "react";
import { Drawer, Layout } from "antd";
import { Link, Outlet } from "react-router-dom";
import DashboardSideMenu from "../components/layout/DashboardSideMenu";
import Theme from "../theme/Theme";
import MainHeader from "../components/layout/MainHeader";
import { GetDefaultPerfCycleApi } from "../api/GetDefaultPerfCycleApi";
import { useDispatch, useSelector } from "react-redux";
import { perfCycleDetails } from "../features/PerfCycleSlice";
import PageLoader from "../components/sub/PageLoader";
import { setTopPlan } from "../features/TopPlanSlice";

const { Sider } = Layout;

function DashboardLayout() {
  const [loading, setLoading] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const proWidth = document.body.clientWidth;
  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const dispatch = useDispatch();

  useEffect(() => {
    /*In tab view collapse menu when loaded*/
    if (proWidth < 720) {
      setCollapsed(true);
    }
  }, []);

  useEffect(() => {
    if (!perfCycleState?.name) {
      getDefaultPerfCycle();
    } else {
      setLoading(false);
    }
  }, []);

  useEffect(() => {}, [perfCycleState]);

  async function getDefaultPerfCycle() {
    setLoading(true);
    const apiResponse = await GetDefaultPerfCycleApi();
    if (apiResponse.success) {
      dispatch(perfCycleDetails(apiResponse.data || {}));
      dispatch(setTopPlan(apiResponse.data?.topPlanLevelName));
      setLoading(false);
    }
  }

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/*Main side menu*/}
      <Sider
        collapsible
        collapsed={collapsed}
        trigger={null}
        breakpoint="lg"
        style={{
          height: "100vh",
          overflow: "hidden",
        }}
        className="transparent-scroll hidden sm:block th-bg-side-menu"
      >
        <Link to="/home">
          <div className="logo" />
        </Link>
        <DashboardSideMenu collapsed={collapsed} />
      </Sider>

      {/*Mobile side menu*/}
      <Drawer
        width="280"
        closable={false}
        placement="left"
        onClose={() => setCollapsed(true)}
        visible={!collapsed}
        className="sm:hidden "
        style={{ padding: 0 }}
        bodyStyle={{ backgroundColor: Theme().sideMenu, padding: 0 }}
      >
        <div className="logo" />
        <DashboardSideMenu />
      </Drawer>
      <Layout className="site-layout">
        <MainHeader
          openMenu={() => setCollapsed(!collapsed)}
          menu={collapsed}
        />
        {loading ? <PageLoader /> : <Outlet />}
      </Layout>
    </Layout>
  );
}

export default DashboardLayout;
